import React from 'react'

import PageSection from 'components/common/PageSection'
import { AgentsSummary } from 'components/configurations/agents/AgentsSummary'
import { useGetAgentsSummary } from 'queries/agents/use-get-agents-summary'
import { messageFromResponseError } from 'utils/strings'

export const AgentsSummaryContainer: React.FC = () => {
  const {
    data: agentsSummary,
    isLoading: isLoadingAgentsSummary,
    isError: isErrorAgentsSummary,
    error: agentsSummaryError
  } = useGetAgentsSummary()

  return (
    <PageSection
      errorMessage={messageFromResponseError(
        agentsSummaryError,
        'We encountered an error while fetching Agents summary. Please try again later.'
      )}
      hasError={isErrorAgentsSummary}
      isLoading={isLoadingAgentsSummary}
      isLoadingOverlayFullScreen={false}
      loadingBoxProps={{
        minHeight: 56,
        maxWidth: '50%'
      }}
    >
      {agentsSummary && <AgentsSummary agentsSummary={agentsSummary} />}
    </PageSection>
  )
}
